export class ListAzureFileSharesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageAccountName",
            "baseName": "storageAccountName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureFileSharesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
